import { Flex, Icon, IconButton, useBreakpointValue } from '@chakra-ui/react';
import { RiMenuLine } from 'react-icons/ri';
import { useAuth } from '../../hooks/auth';
import { useSidebarDrawer } from '../../hooks/sidebarDrawer';
import { Logo } from './Logo';
import { NotificationsNav } from './NotificationsNav';
import { Platform } from './Platform';
import { Profile } from './Profile';

export const Header = (): JSX.Element => {
  const { user: authenticatedUser } = useAuth();

  const { onOpen } = useSidebarDrawer();

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  return (
    <Flex
      as="header"
      w="100vw"
      h="20"
      bg="white"
      mx="auto"
      px="6"
      py="8"
      align="center"
    >
      <Logo />

      {!isWideVersion && (
        <IconButton
          aria-label="Open navigation"
          icon={<Icon as={RiMenuLine} />}
          fontSize="24"
          variant="unstyled"
          onClick={onOpen}
          ml="2"
        />
      )}
      <Flex align="center" ml="auto">
        <NotificationsNav />

        {authenticatedUser.userAssignments.length > 1 && (
          <Platform showAvatar={isWideVersion} />
        )}

        <Profile showProfileData={isWideVersion} />
      </Flex>
    </Flex>
  );
};
